module.exports = __webpack_public_path__ + "static/media/engineCC.ad24a961.jpg";